<template>
  <div id="evolucion-region">
    <template>
      <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
        <!-- window.history.back() $router.go(-1) -->
        <v-icon right dark>arrow_back_ios</v-icon>Volver
      </v-btn>
    </template>
    <v-layout align-center justify-center>
      <v-flex lg10>
        <v-card>
          <v-container>
            <v-toolbar color="white" dark flat dense cad>
              <v-toolbar-title class="indigo--text"
                >Evolucion - Vista por Region</v-toolbar-title
              >
            </v-toolbar>
            <v-form>
              <v-container align-center justify-center>
                <v-layout>
                  <grafica-material-region-evolucion
                    :tipoPrueba="tipoPrueba"
                    :nivelFiltro="nivelFiltro"
                    :fechaFiltro="fechaFiltro"
                  ></grafica-material-region-evolucion>
                </v-layout>
              </v-container>
            </v-form>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Vue from "vue";
import GraficaMaterialRegionEvolucion from "@/modules/distribucion/views/evolucion/GraficaMaterialRegionEvolucion.vue";
import axios from "axios";

export default {
  name: "evolucion-region",
  components: {
    GraficaMaterialRegionEvolucion,
  },
  props: {
    proveedor: {},
    show: Boolean,
    tipeView: "",
    tipo: "",
  },
  data() {
    return {
      contratoId: "",
      id: "",
      tipoPrueba: "",
      nivelFiltro: "",
      fechaFiltro: "",
    };
  },

  computed: {},

  created() {
    this.contratoId = this.$store.getters.contratoStored;
    this.tipeView = this.$route.params.tipeView;
    (this.tipoPrueba = this.$route.params.tipoPrueba),
      (this.nivelFiltro = this.$route.params.nivelFiltro),
      (this.fechaFiltro = this.$route.params.fechaFiltro);
  },
  mounted() {},
  methods: {
    volver() {
      this.$router.back();
    },
  },
};
</script>
